import { Grid, Stack } from '@mui/material';
import { TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';

export function TitleAndContentFieldsMui() {
  const { $t } = useIntl();
  return (
    <Stack spacing={4}>
      <Grid container>
        <Grid item md={12}>
          <TextFieldElement
            name="title"
            label={$t({
              id: 'socialExport.form.title',
              defaultMessage: 'Título',
            })}
            required
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={12}>
          <TextFieldElement
            name="content"
            label={$t({
              id: 'socialExport.form.content',
              defaultMessage: 'Contenido',
            })}
            required
            fullWidth
            multiline
            rows={3}
          />
        </Grid>
      </Grid>
    </Stack>
  );
}
